import BemIt, { addClass } from "@gtechdoodler/bem-it";
import Icon from "../../imagery/Icon";
import Typography from "../../typography/Typography";
import { ButtonProps } from "./Button.types";
import { StyledButton } from "./styling/Button.styles";

const Button: React.FC<ButtonProps> = ({
	className,
	text,
	icon,
	iconPosition = "right",
	variant = "primary",
	colorOn = "bg_white",
	size = "default",
	...props
}) => {
	const block = new BemIt("Button");

	const iconOnly = !text && Boolean(icon);
	const iconSize = iconOnly ? "md" : "sm";
	const smallIconSIze = iconOnly ? "sm" : "xs";

	return (
		<StyledButton
			className={addClass(className).after(block)}
			variant={variant}
			colorOn={colorOn}
			iconOnly={iconOnly}
			iconPosition={iconPosition}
			size={size}
			{...props}
		>
			<Typography
				weight="heaviest"
				variant={size === "default" ? "body" : "body-small"}
				flex="1"
			>
				{text}
			</Typography>
			{icon && (
				<Icon
					name={icon}
					size={size === "default" ? iconSize : smallIconSIze}
				/>
			)}
		</StyledButton>
	);
};

export default Button;
